<template>
  <div>
    <i aria-hidden="true" class="fa fa-trash pull-right"
       @click="removeObj()"
       v-if="showRemoveBtn"></i>
    <div class="form-group">
      <label>If</label>
      <select class="form-control" v-model="state.field">
        <option v-for="(form, index) in schema" :value="form.name"
                :key="'cond-key-' + index"
                v-if="![fieldType.SUBHEADER, fieldType.ACCORDION, fieldType.DIVIDER, fieldType.ROW, fieldType.HEADER ].includes(form.type)">
          {{ form.description }}
        </option>
        <optgroup v-for="form in schema"
                  v-if="['accordion'].includes(form.type)"
                  :label="form.description">
          <option v-for="field in form.values" :value="field.name"
                  v-if="![fieldType.SUBHEADER, fieldType.DIVIDER, fieldType.ROW ].includes(field.type)">
            {{ field.description }}
          </option>
        </optgroup>
      </select>
    </div>
    <div class="form-group">
      <label>State</label>
      <select class="form-control" v-model="state.state">
        <option value="1">Is equal to</option>
        <option value="2">Is not equal to</option>
        <option value="3">Is empty</option>
        <option value="4">Is filled</option>
        <option value="5">Is less than</option>
        <option value="6">Is greater than</option>
      </select>
    </div>
    <div v-show="!['3', '4'].includes(state.state)">
      <div class="form-group">
        <label>Target</label>
        <select class="form-control" v-model="state.to">
          <option value="0">Value</option>
          <option value="1">Another field</option>
        </select>
      </div>
      <div class="form-group" v-show="state.to == 1">
        <label>Select field</label>
        <select class="form-control" v-model="state.targetField">
          <option v-for="(form, index) in schema"
                  :value="form.name" :key="'select-key-' + index"
                  v-if="!['text-entry', 'accordion', 'divider', 'row' ].includes(form.type)">
            {{ form.description }}
          </option>
          <optgroup v-for="form in schema"
                    v-if="['accordion'].includes(form.type)"
                    :label="form.description">
            <option v-for="field in form.values" :value="field.name"
                    v-if="!['text-entry', 'divider', 'row' ].includes(field.type)">
              {{ field.description }}
            </option>
          </optgroup>
        </select>
      </div>
      <div class="form-group" v-show="state.to == 0">
        <label>Value</label>
        <input type="text" class="form-control" v-model="state.value">
      </div>
    </div>
  </div>
</template>

<script>
import {FIELD_TYPE} from "../../../enums/fieldType";

export default {
  name: "ConditionBuilder",
  props: {
    showRemoveBtn: Boolean,
    state: Object,
    removeObj: Function,
    schema: Array
  },
  data() {
    return {
      fieldType: FIELD_TYPE
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConditionBuilder.vue?006ee478